import Recat, { useState, useEffect, useImperativeHandle, useRef, Children } from 'react';
import { SFuncModal, SGeneralForms } from 'shj-components'
import { Checkbox, Spin, InputNumber } from 'antd';
import { receiptWriteOffSaveOrUpdateEntity, receiptWriteOffById } from '@/services/fmsConfig'
import { httpDictServTenant, getEnum } from '@/services/fmsServices'
import type { DragEndEvent } from '@dnd-kit/core';
import { DndContext } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
    const { editData, verifyTransAndArTypeListOld } = props
    const reqMeg = '不能为空';
    const formRef: any = useRef();
    const sequenceList = [
        { label: '正负应收单/正负收款单优先核销 ', value: 'posAndNegFirst' },
        { label: '按交易类型与收款类型关系核销', value: 'transTypeAndArType', disabled: true },
        { label: '按应收日期从前往后核销', value: 'arRecDateAsc' },
    ];
    const nodeList = [
        { label: '应收单提交时', value: 'arSubmit' },
        { label: '收款单确认收款时', value: 'receiptConfirm' },
    ];
    const [sequenceShow, setSequenceShow] = useState(true)
    const [loading, setLoading] = useState(false)
    // const [selectedIndex, setSelectedIndex] = useState(2)
    const [transactionTypeLists, setTransactionTypeList] = useState<any>([])
    const [paymentTypeLists, setPaymentTypeList] = useState<any>([])
    const [verifyTransAndArTypeList, setVerifyTransAndArTypeList] = useState<any>([])

    const onFormRef = () => {
        const { onFormRef } = formRef.current || {}
        return onFormRef?.()
    }
    useEffect(() => {
        initFn();
    }, []);

    const initFn = () => {
        const { id } = editData;
        if (editData?.id) {
            setLoading(true)
            receiptWriteOffById({ id }).then(res => {
                setLoading(false)
                // 回显数据
                const nodeOptions = ['arSubmit', 'receiptConfirm'];
                const sequenceOptions = ['posAndNegFirst', 'transTypeAndArType', 'arRecDateAsc'];
                res.node = nodeOptions.filter(option => res[option] === 1);
                res.sequence = sequenceOptions.filter(option => res[option] === 1);
                // 复制
                if (editData?.showCopy) {
                    const fieldsToReset = ['code', 'name', 'bizTag'];
                    fieldsToReset.forEach(field => res[field] = field === 'bizTag' ? undefined : '');
                    delete res.id;
                    res.verifyTransAndArTypeList.forEach(m => delete m.id);
                }
                setVerifyTransAndArTypeList(res.verifyTransAndArTypeList)
                onFormRef()?.setFieldsValue(res);
            })
        } else {
            onFormRef()?.setFieldsValue({
                node: ['arSubmit', 'receiptConfirm'],
                sequence: ['posAndNegFirst', 'transTypeAndArType', 'arRecDateAsc'],
            })
        }
    };
    // 重置
    // const onReset = () => {
    //   form.resetFields();
    // };
    const onChange = (value) => {
        if (value.includes('transTypeAndArType')) {
            setSequenceShow(true)
        } else {
            setSequenceShow(false)
        }
    }
    const getOptions = async () => {
        setLoading(true)
        let requirementTagList = await getEnum('com.shj.saas.plus.crm.enums.BizOpTypeEnum')
        let paymentTypeList: any = await httpDictServTenant({
            parentKey: 'receiptType', enabled: 1, "orderBys": [
                {
                    "columnName": "sortNumber",
                    "asc": true
                }
            ]
        })
        // 新增默认置核销规则，当收款类型为设计费，交易类型就为设计费，商品款同理
        const transTypeMapping = {
            designFeePayment: 'designFee',
            retailAmountPayment: 'retailAmountFee',
            default: 'constructionFee'
        };

        const verifyTransAndArTypeLists = paymentTypeList.map((m, index) => ({
            transType: transTypeMapping[m.priKey] || transTypeMapping.default,
            arType: m.priKey,
            seq: index + 1
        }));

        let transactionTypeList = await httpDictServTenant({
            parentKey: 'transactionFeeType',
            enabled: 1
        });
        setTransactionTypeList(transactionTypeList)
        setPaymentTypeList(paymentTypeList)
        if (!editData?.id) {
            // onFormRef()?.setFieldsValue({ verifyTransAndArTypeList });
            if(verifyTransAndArTypeListOld.length !== 0){
                setVerifyTransAndArTypeList(verifyTransAndArTypeListOld)
            }else{
                setVerifyTransAndArTypeList(verifyTransAndArTypeLists)
            }
        }
        setLoading(false)
        return Promise.resolve({
            nodeList: nodeList,
            sequenceList: sequenceList,
            requirementTagList,
            paymentTypeList,
            transactionTypeList,
        })
    }

    const DraggableTable = ({ value = [], onChange, transactionTypeList = [], paymentTypeList = [], verifyTransAndArTypeList = [] }) => {
        console.log(paymentTypeList,'paymentTypeList')
        const [items, setItems] = useState<any>([]);
        // 使用 useRef 来跟踪是否已经初始化
        const isInitialized = useRef(false);
        useImperativeHandle(ref, () => ({
            getValue: () => items
        }));
        useEffect(() => {
            // 防止重复初始化
            if (isInitialized.current) return;

            if (Array.isArray(value) && value.length > 0) {
                setItems(value);
                isInitialized.current = true;
            } else if (transactionTypeList.length > 0 && paymentTypeList.length > 0) {
                // const transTypeMapping = {
                //     designFeePayment: 'designFee',
                //     retailAmountPayment: 'retailAmountFee',
                //     default: 'constructionFee'
                //   };
                // const defaultItems = paymentTypeList.map((payment, index) => ({
                //     transType: transTypeMapping[payment.priKey] || transTypeMapping.default,
                //     arType: payment.priKey,
                //     seq: index + 1
                // }));
                setItems(verifyTransAndArTypeList);
                // onChange?.(verifyTransAndArTypeList);
                isInitialized.current = true;
            }
        }, [value, transactionTypeList, paymentTypeList]);

        const onDragEnd = ({ active, over }: DragEndEvent) => {
            if (active.id !== over?.id) {
                const oldIndex = items.findIndex((item) => item.seq === active.id);
                const newIndex = items.findIndex((item) => item.seq === over?.id);

                const newItems = arrayMove(items, oldIndex, newIndex);
                const updatedItems = newItems.map((item, index) => ({
                    ...item,
                    seq: index + 1
                }));

                setItems(updatedItems);
                // onChange?.(updatedItems);
            }
        };

        const DraggableRow = ({ item, index }) => {
            const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
                id: item.seq,
            });

            const style = {
                transform: CSS.Transform.toString(transform),
                transition,
                display: 'flex',
                alignItems: 'center',
                padding: '8px',
                backgroundColor: index % 2 === 0 ? 'rgba(247, 248, 250, 1)' : '#fff',
                cursor: 'move',
            };

            return (
                <div 
                    ref={setNodeRef} 
                    style={style}
                    {...attributes} 
                    {...listeners}
                >
                    <div style={{ width: 100, textAlign: 'center', paddingRight: 60 }}>核销顺序 {item.seq}</div>
                    <div style={{  width: 200, }}>
                        {transactionTypeList.find(t => t.priKey === item.transType)?.name}
                    </div>
                    <div style={{ flex: 1 }}>
                        {paymentTypeList.find(p => p.priKey === item.arType)?.name}
                    </div>
                     
                </div>
            );
        };
        console.log(items, 'items')
        return (
            <div style={{display: 'flex', border: '1px solid #BEBFC2',borderRadius: '3px',}}>
                {/* <div style={{padding: 15, borderRight: '1px solid #BEBFC2'}}>
                    <div style={{marginBottom: 15}}>交易类型</div>
                    <div>
                        {transactionTypeList.map((item: any, index: number) => {
                            return (
                                <div 
                                    style={{
                                        display: 'flex',
                                        width: '200px',
                                        height: '40px',
                                        padding: '2px 10px',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        marginBottom: 5,
                                        borderRadius: selectedIndex === index ? '8px' : '0', // 添加选中状态样式
                                        background: selectedIndex === index ? '#F0F6FF' : 'transparent' // 添加选中状态背景
                                    }}
                                    onClick={()=>setSelectedIndex(index)}
                                >
                                    <img src={require('@/assets/collectionVerificationSPK.svg')} alt="" />
                                    <span style={{paddingLeft: 10}}>{item.name}</span>
                                </div>
                            );
                        })}
                    </div>
                </div> */}
                <div style={{padding: 15, height: 360, overflowY: 'scroll', width: '100%'}}>
                    <div style={{marginBottom: 15}}>排序</div>
                    <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
                    
                    <div style={{ borderRadius: 4 }}>
                        <div style={{
                            display: 'flex',
                            padding: '8px',
                        }}>
                            <div style={{ width: 100, textAlign: 'center',paddingRight: 60 }}>序号</div>
                            <div style={{ width: 200, }}>交易类型</div>
                            <div style={{ flex: 1 }}>收款类型</div>
                        </div>
                        <SortableContext items={items.map(item => item.seq)} strategy={verticalListSortingStrategy}>
                            {items.map((item, index) => (
                                <DraggableRow key={item.seq} item={item} index={index} />
                            ))}
                        </SortableContext>
                    </div>
                </DndContext>
                </div>
               
            </div>

        );
    };


    return (
        <Spin spinning={loading}>
            <SGeneralForms
                layout="vertical"
                ref={formRef}
                httpOptionsFn={getOptions}
                isDetail={editData?.showLook}
                isHideSubmitBtn={editData?.showLook}
                footerAlign="right"
                configs={[
                    {
                        formItem: [
                            {
                                label: 'ID',
                                name: 'id',
                                spanCol: 12,
                                isHideItem: !editData?.id || editData?.showCopy,
                                comConfig: {
                                    disabled: editData?.id,
                                },
                            },
                            {
                                label: '方案名称',
                                name: 'name',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                            },
                            {
                                label: '需求标签',
                                name: 'bizTag',
                                spanCol: 12,
                                type: 'select',
                                data: 'requirementTagList',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    fieldNames: { value: 'key', label: 'description' },
                                },
                            },
                            {
                                label: '是否启用',
                                name: 'enabled',
                                spanCol: 12,
                                type: 'switch',
                                checkedChildren: "是",
                                unCheckedChildren: "否",
                            },
                            {
                                label: '核销生成节点',
                                name: 'node',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                type: 'checkbox',
                                data: 'nodeList',
                                children: <Checkbox.Group options={nodeList} />
                            },
                            {
                                label: '核销顺序',
                                name: 'sequence',
                                spanCol: 24,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                type: 'checkbox',
                                data: 'sequenceList',
                                children: <Checkbox.Group options={sequenceList} onChange={onChange} />
                            },
                        ],
                    },
                    ...(sequenceShow ? [{
                        title: '核销规则',
                        formName: 'verifyTransAndArTypeList',
                        customRenderComponent: ({ value, onChange }) => (
                            transactionTypeLists?.length > 0 ? (
                                <DraggableTable
                                    value={value}
                                    onChange={onChange}
                                    transactionTypeList={transactionTypeLists}
                                    paymentTypeList={paymentTypeLists}
                                    verifyTransAndArTypeList={verifyTransAndArTypeListOld.length !== 0 ? verifyTransAndArTypeListOld: verifyTransAndArTypeList}
                                />
                            ) : null
                        )
                    }] : []) as any,
                ]}
            />
        </Spin>
    )
})
